import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField, Tooltip } from '@mui/material';

import { useStyles } from '../../Style/filterBoxStyles';

const FilterAutocomplete = ({ value, ...props }) => {
  const classes = useStyles();
  return (
    <Autocomplete
      className={classes.autocomplete}
      value={value}
      renderInput={(params) => (
        <TextField
          sx={{ textTransform: 'capitalize' }}
          {...params}
          variant="standard"
          placeholder={value?.length > 0 ? '' : 'All'}
        />
      )}
      {...defaultAutoCompleteProps}
      {...props}
    />
  );
};

const defaultAutoCompleteProps = {
  multiple: true,
  limitTags: 1,
  size: 'small',
  disableCloseOnSelect: true,
  getOptionLabel: (option) => option.name,
  renderOption: (props, option) => (
    <Tooltip title={option.name} placement="right" arrow>
      <li {...props}>{option.name}</li>
    </Tooltip>
  ),
};

FilterAutocomplete.propTypes = {
  value: PropTypes.array,
};

export default FilterAutocomplete;
